import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLoadingStore = defineStore('loading', () => {
  const isPageLoading = ref(false)
  const loadingText = ref('Loading...')

  function startPageLoading(text = 'Loading...') {
    isPageLoading.value = true
    loadingText.value = text
  }

  function stopPageLoading() {
    isPageLoading.value = false
  }

  function setLoadingText(text: string) {
    loadingText.value = text
  }

  return {
    isPageLoading,
    loadingText,
    startPageLoading,
    stopPageLoading,
    setLoadingText
  }
})
